import _isEmpty from 'lodash/isEmpty'
import _get from 'lodash/get'

export default (err) => {
    const isGET = _get(err, "response.config.method", null) == "get"
    let errors = {server: "$general.unexpected-error", isGET}

    if(err.response){
        if(!_isEmpty(err.response.headers) && err.response.headers['content-type'].includes("text/html")){
            errors = {server: "$general.html-debug-error", isGET}
        }else{
            if(!_isEmpty(err.response.data)){
                if(err.response.data.detail){
                    errors = {server: err.response.data.detail, isGET}
                }else{
                    errors = err.response.data
                }
            }else if(err.response.data.message){
                errors = {server: err.response.data.message, isGET}
            }
        }
    }
    if(errors.non_field_errors){
        errors.server = errors.non_field_errors.join(',')
        delete errors.non_field_errors
    }

    return errors
}